export var defaultProps = {
    scrollContainer: window,
    visibilityHeight: 400,
    onToggle: function (isShow) { },
    right: 40,
    bottom: 40,
    zIndex: 99,
    onClick: function () { },
    duration: 500,
};
